<div class="modal-header">
  <h4 class="modal-title pull-left">
    {{'login.logout' | translate}}
  </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modal.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  {{'login.logout_confirm' | translate}}
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="logOut(false)">{{'login.logout' | translate}}</button>
  <button type="button" class="btn btn-primary" (click)="logOut(true)" *ngIf="multipleActiveTenants">{{'login.close_all_active_sessions' | translate}}</button>
  <button type="button" class="btn btn-secondary" (click)="modal.hide()">{{'common.actions.cancel' | translate}}</button>
</div>